function crewMembers(employeeList) {
  if (!employeeList || employeeList.length === 0) {
    return <p>No crew members assigned.</p>;
  }

  return (
    <ul>
      {employeeList.map((member) => (
        <li key={member.employeeId}>
          {member.employeeName} - {member.employeeRole} ({member.mobileNumber})
        </li>
      ))}
    </ul>
  );
}

export default crewMembers